import moment from "moment"

// B2 (CDC 16.10) : rendez-vous (état 27) que la grille du Planning ne montre
// pas, ou à risque. La grille couvre 07:00–18:00 sur 7 jours au plus.
// - `urgents` : heure passée sans dispatch (rouge, en tête) ;
// - `horsPlage` : avant 07:00 ou dès 18:00 (orange) ;
// - `plusTard` : au-delà des 7 jours de la grille (repliable, pas compté).
export const RDV_DEBUT = 7
export const RDV_FIN = 18
export const RDV_JOURS_GRILLE = 7

export const dateRdv = (dm) =>
	dm && dm.date_rendez_vous
		? moment(dm.date_rendez_vous, "DD-MM-YYYY HH:mm")
		: null

export const classerRdv = (dms, maintenant = moment()) => {
	const urgents = []
	const horsPlage = []
	const plusTard = []
	const finGrille = maintenant
		.clone()
		.startOf("day")
		.add(RDV_JOURS_GRILLE, "days")
	;(dms || []).forEach((dm) => {
		const d = dateRdv(dm)
		if (!d || !d.isValid()) return
		if (d.isBefore(maintenant)) {
			const jours = maintenant
				.clone()
				.startOf("day")
				.diff(d.clone().startOf("day"), "days")
			urgents.push({
				dm,
				date: d,
				tag:
					jours >= 1
						? `Passé de ${jours} j`
						: "Heure passée, pas dispatché",
			})
			return
		}
		if (!d.isBefore(finGrille)) {
			const jours = d
				.clone()
				.startOf("day")
				.diff(maintenant.clone().startOf("day"), "days")
			plusTard.push({ dm, date: d, tag: `Dans ${jours} j (hors grille)` })
			return
		}
		const h = d.hours() + d.minutes() / 60
		if (h < RDV_DEBUT || h >= RDV_FIN)
			horsPlage.push({ dm, date: d, tag: "Hors 07:00–18:00" })
	})
	const parDate = (a, b) => a.date.valueOf() - b.date.valueOf()
	return {
		urgents: urgents.sort(parDate),
		horsPlage: horsPlage.sort(parDate),
		plusTard: plusTard.sort(parDate),
	}
}

// Bandeau du dispatch : RDV arrivés à leur heure sans dispatch.
export const rdvEnRetard = (dms, maintenant = moment()) =>
	classerRdv(dms, maintenant).urgents
